var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6482_26858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9787 3.75H4.26117C3.66188 3.75134 3.08752 3.99001 2.66376 4.41377C2.23999 4.83753 2.00134 5.41189 2 6.01118V22.7287C2.00134 23.3279 2.23999 23.9023 2.66376 24.3261C3.08752 24.7498 3.66188 24.9885 4.26117 24.9898H20.9787C21.578 24.9885 22.1523 24.7498 22.5761 24.3261C22.9998 23.9023 23.2385 23.3279 23.2398 22.7287V6.01118C23.2385 5.41189 22.9998 4.83753 22.5761 4.41377C22.1523 3.99001 21.578 3.75134 20.9787 3.75Z",
    stroke: "#2B4EA2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54688 11.2227H11.9331",
    stroke: "#2B4EA2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54688 15.8711H18.2085",
    stroke: "#2B4EA2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34375 1.00781V5.98749",
    stroke: "#2B4EA2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8984 1.00781V5.98749",
    stroke: "#2B4EA2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6482_26858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.2398,
    height: 25.9837,
    fill: "white",
    transform: "translate(0 0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.aacf265db649ec18158c6e8992253266.svg";
export { ForwardRef as ReactComponent };